import { render, staticRenderFns } from "./SArticlesItems.vue?vue&type=template&id=73ae6c69"
import script from "./SArticlesItems.vue?vue&type=script&lang=js"
export * from "./SArticlesItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports